import MaterialSearchPicker from './MaterialSearchPicker'

function SearchPicker() {
  return null
}

SearchPicker.Material = MaterialSearchPicker

export default SearchPicker
